import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import storage from '../utils/storage'


const index = () => import('@/components')
const home = () => import('@/views/home/home.vue')

const login = () => import('@/views/login/login.vue')
const sign = () => import('@/views/login/sign.vue')
const account = () => import('@/views/login/account.vue')
const accountdetails = () => import('@/views/login/accountDetails.vue')
const orders = () => import('@/views/login/orders.vue')
const orderdetails = () => import('@/views/login/orderDetails.vue')
const logis = () => import('@/views/login/logis.vue')
const password = () => import('@/views/login/password.vue')
const wallet = () => import('@/views/login/wallet.vue')
const rewards = () => import('@/views/login/rewards.vue')

const useraddress = () => import('@/views/login/userAddress.vue')

const cart = () => import('@/views/cart/cart.vue')

// const delivery = () => import('@/views/cart/delivery.vue')
// const pickup = () => import('@/views/cart/pickup.vue')
// const address = () => import('@/views/cart/address.vue')
// const paypal = () => import('@/views/cart/paypal.vue')

const createOrder = () => import('@/views/order/createOrder.vue')
const delivery = () => import('@/views/order/components/delivery.vue')
// const address = () => import('@/views/order/components/address.vue')
const payType = () => import('@/views/order/components/payType.vue')


const all = () => import('@/views/navList/all/all.vue')
const shop = () => import('@/views/navList/shop/shop.vue')
const shopdetails = () => import('@/views/navList/shop/shopdetails.vue')
const brand = () => import('@/views/navList/brand/poipularbrands.vue')
const bulk = () => import('@/views/bulk/bulk.vue')



const information = () => import('@/views/info/information.vue')
const informationZh = () => import('@/views/info/information-zh.vue')

const download = () => import('@/views/download/appDownload.vue')
const privacyPolicy = ()=>import("@/views/privacyPolicy")


//避免重复点击报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  // console.log(location)
  return originalPush.call(this, location).catch(err => err)
}
// Router.prototype.replace = function replace(location) {
//   return originalPush.call(this, location).catch(err => err);
// };

Vue.use(Router)
const router = new Router({
  linkExactActiveClass: 'active',
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return {
      x: 0,
      y: 0
    }
  },
  routes: [

    {
      path: '/',
      // name: 'home',
      redirect: '/home'
    },

    {
      path: '/home',
      name: 'Home',
      component: index,
      children: [
        {
          path: '/home',
          name: 'home',
          meta: { title: 'home' },
          component: all
        },
        {
          path: '/page',
          name: 'page',
          meta: { title: 'page' },
          component: () => import('@/components/page')
        },
        {
          path: '/shop',
          name: 'shop',
          meta: { title: 'shop' },
          component: shop,
        },
        {
          path: '/shop/shopdetails/:goodsId',
          name: 'shopdetails',
          meta: { title: 'shopdetails' },
          component: shopdetails
        },

        {
          path: '/brand',
          name: 'brand',
          component: brand
        },
        {
          path: '/home/login',
          name: 'Login/Register',
          component: login
        },
        {
          path: '/home/sign',
          // name: 'Login/Register',
          component: sign
        },
        // {
        //   path: '/home/account',
        //   // name: 'home',
        //   redirect: '/home/account/accountdetails'
        // },
        {
          path: '/home/account',
          name: 'AccountInformation',
          component: account,
          meta: {
            auth: true//添加字段判断该页面是否需要登录
          },
          children: [
            {
              path: '/home/account/accountdetails',
              name: '',
              component: accountdetails,
              meta: {
                auth: true
              },
            },
            {
              path: '/home/account/orders',
              name: 'orders',
              component: orders,
              meta: {
                auth: true
              },
            },
            {
              path: '/home/account/orderdetails/:orderNo',
              name: 'orderdetails',
              component: orderdetails,
              meta: {
                auth: true
              },
            },
            {
              path: '/home/account/useraddress',
              name: 'useraddress',
              component: useraddress,
              meta: {
                auth: true
              },
            },
            {
              path: '/home/account/logis',
              name: 'logis',
              component: logis,
              meta: {
                auth: true
              },
            },
            {
              path: '/home/account/password',
              name: 'password',
              component: password,
              meta: {
                auth: true
              },
            },
            {
              path: '/home/account/wallet',
              name: 'wallet',
              component: wallet,
              meta: {
                auth: true
              },
            },
            {
              path: '/home/account/rewards',
              name: 'rewards',
              component: rewards,
              meta: {
                auth: true
              },
            },
          ]
        },
        {
          path: '/home/cart',
          name: 'Cart',
          component: cart
        },
        {
          path: '/home/createOrder',
          name: 'CreateOrder',
          component: createOrder,
          redirect: {
            name: 'Delivery'
          },
          children: [
            {
              path: '/home/createOrder/delivery',
              name: 'Delivery',
              component: delivery
            },
            // {
            //   path: '/home/createOrder/address',
            //   name: 'Address',
            //   component: address
            // },
            {
              path: '/home/createOrder/payType',
              name: 'PayType',
              component: payType
            },
          ]
        },


        {
          path: '/home/bulk',
          name: 'bulk',
          component: bulk
        },
        {
          path: "/home/about-us/information",
          name: 'information',
          component: information
        },
        {
          path: "/home/about-us/information-zh",
          name: 'informationZh',
          component: informationZh
        },
        {
          path:'/home/privacyPolicy',
          name:"privacyPolicy",
          component:privacyPolicy,
        }
      ],


    },
    {
      path:'/download',
      name:"download",
      component:download,
    },



  ]
})
// 路由守卫
router.beforeEach((to, from, next) => {
  // to要跳转到的路径
  // from从哪个路径来
  // next往下执行的回调
  // 在localStorage中获取token， store由于初始化晚的问题无法正确处理当前登录缓存记录
  // let token = localStorage.getItem('userName')
  // 判断该页面是否需要登录
  let token = storage.get('token')
  if (to.meta.auth) {
    // 如果token存在直接跳转
    if (token) {
      next()
    } else {
      // 否则跳转到login登录页面
      next({
        path: '/home/login',
        // 跳转时传递参数到登录页面，以便登录后可以跳转到对应页面
        query: {
          redirect: to.fullPath
        }
      })
    }
  } else {
    // 如果不需要登录，则直接跳转到对应页面
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js